import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { AnimatePresence, motion } from 'motion/react';

import { AnimatedIcon } from '@components/primitives/AnimatedIcon';
import { cn, easeOutSmooth } from '@components/primitives/utilities';

import styles from './styles.module.css';

export type MenuCheckboxProps = DropdownMenu.DropdownMenuCheckboxItemProps & {
  indicator?: 'check' | 'dot';
};

export function MenuCheckbox({
  className,
  children,
  checked,
  onSelect,
  indicator = 'check',
  ...props
}: MenuCheckboxProps) {
  return (
    <DropdownMenu.CheckboxItem
      className={cn(styles.menuItem, className)}
      checked={checked}
      onSelect={(e) => {
        e.preventDefault();
        onSelect?.(e);
      }}
      {...props}
    >
      {indicator === 'dot' ? (
        <div className={styles.dot} />
      ) : (
        <div
          className={styles.checkbox}
          aria-checked={checked === 'indeterminate' ? 'mixed' : checked}
        >
          <AnimatePresence initial={false}>
            {checked && (
              <motion.div className={styles.check}>
                <AnimatedIcon.Check
                  strokeWidth={4}
                  initial="from"
                  animate="to"
                  transition={{
                    duration: 0.2,
                    delay: 0.02,
                    ease: easeOutSmooth,
                  }}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      )}

      <span className={styles.label}>{children}</span>
    </DropdownMenu.CheckboxItem>
  );
}
